abstract class LoginProcess {
  logged: boolean;
  message: string;

  constructor(
    public isLogged: boolean,
    public logMessage: string,
  ) {
    this.logged = isLogged;
    this.message = logMessage;
  }
}

export class LoginProcessAdapter extends LoginProcess {
  constructor(isLogged: boolean, logMessage: string) {
    super(isLogged, logMessage);
  }
}
